import { TweenLite, Power2 } from 'gsap';
import 'gsap/src/uncompressed/plugins/ScrollToPlugin';

class Form {
  constructor(windowSizes) {
    this.activeSection = 0;
    this.container = document.querySelector('.form-page');
    console.log('init form 1.3');
    if (this.container) {
      this.files = [];
      this.form = this.container.querySelector('#add-form');
      this.sections = this.container.querySelectorAll('.form-page__section');
      this.nextBtns = this.container.querySelectorAll('.form-page__next--form');
      this.backBtns = this.container.querySelectorAll('.form-page__next--back');
      this.saveFormBtn = document.getElementById('save-form-btn');
      this.depense = this.container.querySelector(
        '.form-page__depense-container'
      );
      this.recette = this.container.querySelector(
        '.form-page__recette-container'
      );
      this.nav = this.container.querySelector('.form-page__nav');

      if (this.nav) {
        this.navBtns = this.nav.querySelectorAll('.form-page__nav__li');
        this.dropzones = this.container.querySelectorAll(
          '.form-page__field__dropzone'
        );
        this.submitFormLink = document.getElementById('submit-form-link');
        this.submitFormBtn = document.getElementById('submit-form-btn');

        this.init();
      }

      this.resultPage = this.container.querySelector('.form-page__result');
      if (this.resultPage) {
        this.scrollToResult();
      }
    }
  }

  init() {
    this.initEvents();
    this.initYesNo();
    this.initChoices();
    this.initDepenses();
    this.initRecettes();
    this.showSection(this.activeSection);
    this.initDropzones();
    //this.fillInputs();
    this.initFormEvent();
    this.initFieldsEvents();
    this.initDates();
  }

  scrollToResult() {
    TweenLite.to(window, 1, {
      scrollTo: { y: this.resultPage, offsetY: 210 },
      ease: Power2.easeInOut,
    });
  }

  stringToSlug(str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    var from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;';
    var to = 'aaaaeeeeiiiioooouuuunc------';
    for (var i = 0, l = from.length; i < l; i++) {
      str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str
      .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
      .replace(/\s+/g, '-') // collapse whitespace and replace by -
      .replace(/-+/g, '-'); // collapse dashes

    return str;
  }
  removeExtension(filename) {
    var lastDotPosition = filename.lastIndexOf('.');
    if (lastDotPosition === -1) return filename;
    else return filename.substr(0, lastDotPosition);
  }

  initDates() {
    this.dates = this.container.querySelectorAll(
      '.form-page__field__input-date'
    );

    Array.from(this.dates, (d, index) => {
      d.onchange = function () {
        if (d.value === '') {
          d.classList.add('form-page__field__input-date--empty');
        } else {
          //console.log('remove');
          d.classList.remove('form-page__field__input-date--empty');
        }
      };
    });
  }

  /** Ajouter une ligne de dépense */
  addLine(container, depense, item, name) {
    const clone = item.cloneNode(true);
    const cloneField = clone.querySelector('.form-page__depenses__item__input');

    const inputValue = clone.querySelector('.form-page__depenses__item__value');
    const cloneFieldMoney = clone.querySelector(
      '.form-page__depenses__item__input-money'
    );
    cloneField.placeholder = name;
    cloneField.value = '';
    cloneFieldMoney.value = '';

    this.setChangeInput(cloneField, cloneFieldMoney, inputValue);

    cloneField.addEventListener('input', () => {
      this.setChangeInput(cloneField, cloneFieldMoney, inputValue);
    });

    cloneFieldMoney.addEventListener('input', () => {
      this.setChangeInput(cloneField, cloneFieldMoney, inputValue);
    });
    // Ajouter la nouvelle ligne
    container.appendChild(clone);
  }

  initDepenses() {
    const depense = this.depense;
    const container = depense.querySelector('.form-page__depenses__list');
    const item = depense.querySelector('.form-page__depenses__item');
    const field = item.querySelector('.form-page__depenses__item__input');
    const fieldMoney = item.querySelector(
      '.form-page__depenses__item__input-money'
    );
    const inputValue = depense.querySelector(
      '.form-page__depenses__item__value'
    );

    const name = field.placeholder;
    field.placeholder = name + ' 1';
    this.setChangeInput(field, fieldMoney, inputValue);

    field.addEventListener('input', () => {
      this.setChangeInput(field, fieldMoney, inputValue);
    });
    fieldMoney.addEventListener('input', () => {
      this.setChangeInput(field, fieldMoney, inputValue);
    });

    for (let i = 0; i < 4; i++) {
      const lineName = name + ' ' + (i + 2);
      this.addLine(container, depense, item, lineName);
    }
    const button = depense.querySelector('.form-page__depense-plus');
    button.addEventListener('click', () => {
      const lineName = name;
      this.addLine(container, depense, item, lineName);
    });
  }

  addMoneyFieldEvents(item) {
    const fieldMoney = item.querySelector(
      '.form-page__depenses__item__input-money'
    );
    const fieldLabel = item.querySelector('.form-page__depenses__item__name');
    const fieldPercent = item.querySelector(
      '.form-page__depenses__item__input-percent'
    );
    const fieldValue = item.querySelector('.form-page__depenses__item__value');
    const fieldText = item.querySelector(
      '.form-page__depenses__item__input-text'
    );

    fieldMoney.addEventListener('input', () => {
      this.setChangeInputRecette(fieldLabel, fieldText, fieldMoney, fieldValue);
    });
    if (fieldText) {
      fieldText.addEventListener('input', () => {
        this.setChangeInputRecette(
          fieldLabel,
          fieldText,
          fieldMoney,
          fieldValue
        );
      });
    }
  }

  initRecettes() {
    const recette = this.recette;
    const items = recette.querySelectorAll('.form-page__depenses__item');

    const list = recette.querySelector('.form-page__depenses__list');
    const button = recette.querySelector('.form-page__recette-plus');
    this.recetteModelDiv = items[items.length - 1].cloneNode(true);
    button.addEventListener('click', () => {
      const itemModel = this.recetteModelDiv.cloneNode(true);
      const newItem = this.addMoneyFieldEvents(itemModel);
      list.appendChild(itemModel);
    });

    Array.from(items, (item, index) => {
      const newItem = this.addMoneyFieldEvents(item);
    });
  }

  setChangeInputRecette(fieldLabel, fieldText, fieldMoney, fieldValue) {
    const newName = fieldLabel ? fieldLabel.textContent : fieldText.value;
    let value = fieldMoney.value;
    if (value < 0) {
      value = 0;
    }
    const newMoney = value;
    fieldMoney.value = value;
    fieldValue.value = newName + '-sep-' + newMoney;
    this.calculateRecetteTotal();
  }

  calculateRecetteTotal() {
    const moneyFields = this.recette.querySelectorAll(
      '.form-page__depenses__item__input-money'
    );
    const totalContainer = this.container.querySelector(
      '.form-page__depenses__total__number-recette'
    );
    let total = 0;
    Array.from(moneyFields, (moneyField, index) => {
      total += Number(moneyField.value);
    });

    Array.from(moneyFields, (moneyField, index) => {
      this.moneyPercent(moneyField, total);
    });

    totalContainer.innerHTML = total;
  }

  moneyPercent(moneyField, total) {
    const percentContainer = moneyField.parentElement.querySelector(
      '.form-page__depenses__item__input-percent'
    );
    const lineValue = moneyField.value;

    const percent = (lineValue / total) * 100;
    let resultPercent = percent.toFixed(0);
    resultPercent = isNaN(resultPercent) ? 0 : resultPercent;
    percentContainer.innerHTML = resultPercent;
  }

  calculateTotal() {
    const moneyFields = this.depense.querySelectorAll(
      '.form-page__depenses__item__input-money'
    );
    const totalContainer = this.container.querySelector(
      '.form-page__depenses__total__number'
    );
    let total = 0;
    Array.from(moneyFields, (moneyField, index) => {
      total += Number(moneyField.value);
    });

    totalContainer.innerHTML = total;
  }

  setChangeInput(cloneField, cloneFieldMoney, inputValue) {
    const newName = cloneField.value;
    let newMoney = cloneFieldMoney.value;

    if (newMoney < 0) {
      newMoney = 0;
    }

    cloneFieldMoney.value = newMoney;
    //console.log(newName + "-sep-" + newMoney);
    inputValue.value = newName + '-sep-' + newMoney;
    this.calculateTotal();
  }

  initEvents() {
    Array.from(this.nextBtns, (btn, index) => {
      btn.addEventListener('click', this.onNextSection.bind(this));
    });
    Array.from(this.backBtns, (btn, index) => {
      btn.addEventListener('click', this.onPrevSection.bind(this));
    });
    this.submitFormLink.addEventListener('click', this.onSubmitForm.bind(this));
    this.submitFormBtn.addEventListener('click', this.onSubmitInput.bind(this));
    this.saveFormBtn.addEventListener('click', this.onSave.bind(this));
    const draftId = this.form.dataset.draft;
    if (draftId) {
      this.loadDraft(draftId);
    }
  }

  loadDraft(draftId) {
    fetch(
      `/wp-content/themes/fondation-ca/draft/loadDraft.php?draftId=${draftId}`,
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Cache-Control': 'no-cache',
        },
      }
    )
      .then((response) => response.json())
      .then((res) => {
        if (res && res.fields) {
          const fieldsDiv = this.form.querySelectorAll('.form-page__field');

          Array.from(fieldsDiv).map((e) => {
            res.fields.map((f) => {
              const type = f.type;

              if (Number(e.dataset.id) === Number(f.field_id)) {
                if (
                  type === 'texte' ||
                  type === 'nombre' ||
                  type === 'tel' ||
                  type === 'email' ||
                  type === 'oui / non' ||
                  type === 'choix'
                ) {
                  if (type === 'oui / non') {
                    const inputs = e.querySelectorAll(
                      '.form-page__field__yesno'
                    );
                    if (f.value === 'oui' || f.value === ' oui ') {
                      if (inputs[0]) inputs[0].click();
                    }
                    if (f.value === 'non' || f.value === ' non') {
                      if (inputs[1]) inputs[1].click();
                    }
                  }

                  if (type === 'choix') {
                    const inputs = e.querySelectorAll(
                      '.form-page__field__choix__item'
                    );
                    Array.from(inputs).map((c) => {
                      const text = c.innerText;
                      const value = f.value;

                      if (
                         text.trim() == value.trim() ||
                        `${c.innerText} ` == f.value
                      ) {
                        c.click();
                      }
                    });
                  }

                  const input = e.getElementsByTagName('input')[0];
                  if (input) input.value = f.value;
                }

                if (type === 'date') {
                  const selects = e.getElementsByTagName('select');
                  const yearInput = e.getElementsByTagName('input')[0];
                  const values = f.value.split('-');
                  Array.from(selects).map((e, i) => {
                    e.value = values[i];
                  });
                  if (values.length && values[2]) yearInput.value = values[2];
                }
                if (type === 'textarea') {
                  const input = e.getElementsByTagName('textarea')[0];
                  if (input) input.value = f.value;
                }
                if (
                  type === 'select' ||
                  type === 'caisses' ||
                  type === 'départements'
                ) {
                  const input = e.getElementsByTagName('select')[0];
                  if (input) input.value = f.value;
                }
                if (type === 'dropzone' && f.value) {
                  const input = e.getElementsByTagName('input')[0];
                  if (input) input.value = f.value;

                  const dropzones = Array.from(
                    this.container.querySelectorAll(
                      '.form-page__field__dropzone'
                    )
                  );

                  const dropzoneEl = e.querySelector(
                    '.form-page__field__dropzone'
                  );
                  let dropId = null;
                  dropzones.map((d, i) => {
                    if (d === dropzoneEl) {
                      dropId = i;
                    }
                  });

                  const imgDropzone = dropzoneEl
                    ? Dropzone.forElement(dropzoneEl)
                    : null;

                  const files = f.value.split(',');
                  imgDropzone &&
                    files.map((e) => {
                      const mockFile = {
                        name: e,
                        size: 12345,
                        accepted: true,
                        kind: 'image',
                      };
                      imgDropzone.emit('addedfile', mockFile);

                      // Add download link
                      let anchorEl = document.createElement('a');
                      anchorEl.setAttribute(
                        'href',
                        `/wp-content/themes/fondation-ca/forms/uploads/${e}`
                      );
                      anchorEl.setAttribute('target', '_blank');
                      this.files[dropId].push(e);

                      const previews =
                        dropzoneEl.querySelectorAll('.dz-preview');
                      previews &&
                        Array.from(previews).length &&
                        Array.from(previews).map((pDiv) => {
                          pDiv.querySelector('.dz-image').appendChild(anchorEl);
                        });
                    });
                }
                if (type === 'financement' || type === 'recettes') {
                  const values = f.value.split('__');
                  values.map((v, i) => {
                    /** Si il y a des champs supplémentaires dans autre financement */
                    if (type === 'recettes' && i > 11 && v !== '') {
                      const list = e.querySelector(
                        '.form-page__depenses__list'
                      );
                      const itemModel = this.recetteModelDiv.cloneNode(true);
                      this.addMoneyFieldEvents(itemModel);
                      list.appendChild(itemModel);
                    }
                    if (type === 'financement' && i > 4 && v !== '') {
                      const depense = this.depense;
                      const container = depense.querySelector(
                        '.form-page__depenses__list'
                      );
                      const item = depense.querySelector(
                        '.form-page__depenses__item'
                      );
                      this.addLine(
                        container,
                        depense,
                        item,
                        'Poste de dépense'
                      );
                    }

                    const inputs = Array.from(
                      e.querySelectorAll('.form-page__depenses__item')
                    );
                    if (!inputs[i]) return;
                    const valueInputField = inputs[i].querySelector(
                      type === 'financement'
                        ? '.form-page__depenses__item__input'
                        : '.form-page__depenses__item__input-text'
                    );
                    const valueMoneyField = inputs[i].querySelector(
                      '.form-page__depenses__item__input-money'
                    );
                    const valueField = inputs[i].querySelector(
                      '.form-page__depenses__item__value'
                    );
                    const defValue = v.split('-sep-');
                    if (valueInputField) valueInputField.value = defValue[0];
                    if (valueMoneyField) valueMoneyField.value = defValue[1];
                    if (valueField) valueField.value = v;
                  });
                  this.calculateRecetteTotal();
                  this.calculateTotal();
                }
              }
            });
          });
        } else {
          alert('Désolé, votre sauvegarde de formulaire a expiré.');
        }
      })
      .catch((err) => {
        console.log(err);
        alert('Désolé, votre sauvegarde de n\'a pas pu être chargée complètement pour une raison inconnue.');
      });
  }
  onSave() {
    const form = this.form;
    const fieldsDiv = form.querySelectorAll('.form-page__field');

    const fields = Array.from(fieldsDiv).map((e) => {
      const type = e.dataset.type;
      const label = e.dataset.label;
      const id = Number(e.dataset.id);
      if (
        type === 'texte' ||
        type === 'nombre' ||
        type === 'tel' ||
        type === 'email' ||
        type === 'oui / non' ||
        type === 'choix'
      ) {
        const input = e.getElementsByTagName('input')[0];
        const i = {
          name: input.name,
          value: input.value,
          label,
          id,
          type,
        };
        return i;
      }
      if (type === 'textarea') {
        const input = e.getElementsByTagName('textarea')[0];
        const i = {
          name: input.name,
          value: input.value,
          label,
          id,
          type,
        };
        return i;
      }

      if (type === 'date') {
        const select1 = e.getElementsByTagName('select')[0];
        const select2 = e.getElementsByTagName('select')[1];
        const input = e.getElementsByTagName('input')[0];
        const i = {
          name: input.name,
          value: `${select1.value}-${select2.value}-${input.value}`,
          label,
          id,
          type,
        };
        return i;
      }
      if (type === 'select' || type === 'caisses' || type === 'départements') {
        const select = e.getElementsByTagName('select')[0];
        const i = {
          name: select.name,
          value: select.value,
          label,
          id,
          type,
        };
        return i;
      }
      if (type === 'financement' || type === 'recettes') {
        const inputs = e.querySelectorAll('.form-page__depenses__item__value');
        let values = '';
        Array.from(inputs).map((f) => {
          values += `${f.value}__`;
        });
        const i = {
          name: type,
          value: values,
          label: type,
          id,
          type,
        };
        return i;
      }
      if (type === 'dropzone') {
        const input = e.getElementsByTagName('input')[0];
        const i = {
          name: input.name,
          value: input.value,
          label,
          id,
          type,
        };
        return i;
      }
    });
    this.saveFields(fields);
  }
  saveFields(fields) {
    const data = new URLSearchParams({
      action: 'save_form',
      fields: JSON.stringify(fields),
    });
    fetch('/wp-content/themes/fondation-ca/draft/saveDraft.php', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Cache-Control': 'no-cache',
      },
      body: data,
    })
      .then((response) => response.json())
      .then((res) => {
        const { secret } = res;
        const link = `${window.location.origin}${window.location.pathname}?draft=${secret}`;
        const draftBox = document.querySelector('#draft-box');
        draftBox.style.display = 'block';
        const draftLink = document.querySelector('#draft-link');
        draftLink.innerHTML = link;
        draftLink.href = link;
        document.querySelector('.form-page__nav').style.display = 'none';
        document.querySelector('#add-form').style.display = 'none';
        TweenLite.to(window, 0, {
          scrollTo: { y: draftBox, offsetY: 210 },
          ease: Power2.easeInOut,
        });
        document
          .querySelector('#draft-mail-submit')
          .addEventListener('click', (e) => {
            e.preventDefault();
            const input = document.querySelector('#draft-mail-input').value;
            const data = new URLSearchParams({
              action: 'send_form',
              to: input,
              subject: `Fondation Crédit Agricole Pays de France - Lien pour continuer votre soumission`,
              message: `Madame, Monsieur,<br /><br /> Merci d’avoir enregistré votre progression dans le formulaire sur le site de la Fondation Crédit Agricole Pays de France. <br /><br /> Vous pouvez utiliser ce lien unique pour revenir à votre formulaire depuis n’importe quelle machine. ${link}`,
            });
            fetch('/wp-content/themes/fondation-ca/draft/sendDraft.php', {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cache-Control': 'no-cache',
              },
              body: data,
            })
              .then((response) => response.json())
              .then((res) => {
                window.location = `/formulaire-de-depot-de-projet-en-ligne-lien-envoye/?mail=${input}&draft=${secret}`;
              })
              .catch((err) => {
                alert(
                  "Désolé, votre formulaire n'a pas pu être sauvegardé pour une raison inconnue. Vous pouvez terminer de remplir tout le formulaire sans le système de sauvegarde progressive ou nous contacter via le lien de contact en bas de page pour nous informer du problème."
                );
                console.log(err);
              });
          });

        document.querySelector('#draft-back').addEventListener('click', (e) => {
          document.querySelector('.form-page__nav').style.display = 'block';
          document.querySelector('#add-form').style.display = 'block';
          document.querySelector('#draft-box').style.display = 'none';
          setTimeout(() => {
            document
              .querySelectorAll('.form-page__section')[0]
              .classList.add('form-page__section--active');
          }, 100);
        });
      })
      .catch((err) => console.log(err));
  }
  onSubmitForm(e) {
    const section = this.sections[this.activeSection];
    section.sectionClicked = true;

    e.preventDefault();
    //console.log("> submit");

    this.checkRequiredFields(this.activeSection, (errors) => {
      //console.log("check res errors", errors.length);
      if (errors.length) {
        this.showErrors(this.activeSection, errors);
      } else {
        this.clearErrors(this.activeSection);
        //console.log("> submit OK !!!");

        const _this = this;
        grecaptcha.ready(function () {
          grecaptcha
            .execute('6Ldl4FgaAAAAAMJRoYuRwkAaGze2QOdSAW4zX0k3', {
              action: 'submit',
            })
            .then(function (token) {
              // Add your logic to submit to your backend server here.
              _this.form.submit();
            });
        });
      }
    });
  }

  onSubmitInput(e) {
    e.preventDefault();
    //console.log('> submit input');
  }

  inputChange() {
    this.checkRequiredFields(this.activeSection, (errors) => {
      //console.log("check res errors", errors.length);
      if (errors.length) {
        this.showErrors(this.activeSection, errors);
      } else {
        this.clearErrors(this.activeSection);
      }
    });
  }

  initFieldsEvents() {
    const sectionInputs = this.container.getElementsByTagName('input');
    const sectionTextAreas = this.container.getElementsByTagName('textarea');
    const sectionSelects = this.container.getElementsByTagName('select');

    Array.from(sectionInputs, (field, index) => {
      const placeholder = field.placeholder;
      field.addEventListener('input', () => {
        this.inputChange();
      });
      field.addEventListener('focusin', () => {
        field.placeholder = '';
      });
      field.addEventListener('focusout', () => {
        field.placeholder = placeholder;
      });
    });

    Array.from(sectionSelects, (field, index) => {
      field.addEventListener('change', () => {
        this.inputChange();
      });
    });

    Array.from(sectionTextAreas, (field, index) => {
      const placeholder = field.placeholder;
      field.addEventListener('input', () => {
        this.inputChange();
      });
      field.addEventListener('focusin', () => {
        field.placeholder = '';
      });
      field.addEventListener('focusout', () => {
        field.placeholder = placeholder;
      });
    });
  }

  initFormEvent() {
    this.form.addEventListener('submit', function (event) {
      var data = new FormData(this.form);
      var output = '';
      for (const entry of data) {
        output = entry[0] + '=' + entry[1] + '\r';
      }
      //log.innerText = output;
      event.preventDefault();
      //console.log('output', output);
    });
  }

  initYesNo() {
    const container = this.container.querySelectorAll(
      '.form-page__field__yesno-container'
    );

    Array.from(container, (c, index) => {
      const yes = c.querySelector('.form-page__field__yesno--yes');
      const no = c.querySelector('.form-page__field__yesno--no');
      const noPlaceholder = c.parentElement.querySelector('.form-page__field__yesno--message');
      const input = c.parentElement.getElementsByTagName('input')[0];
      const group = c.parentElement.parentElement;
      const groupId = group.querySelector('.form-page__field').getAttribute('data-id');

      var groupInfos = false;

      // on cache le groupe suivant si c'est bien un groupe
      const nextInfos = group.nextElementSibling;
      if (groupId != '52' && nextInfos && nextInfos.classList.contains('form-page__group')) {
        groupInfos = nextInfos
        groupInfos.style.display = 'none';
      }

      // on cache le placeholder
      if (noPlaceholder) noPlaceholder.style.display = 'none';

      yes.addEventListener('click', () => {
        input.value = 'oui';
        yes.classList.add('form-page__field__yesno--active-yes');
        no.classList.remove('form-page__field__yesno--active-no');
        
         // on affiche le groupe suivant
        if (groupInfos) groupInfos.style.display = 'block';

        // on cache le placeholder
        if (noPlaceholder) noPlaceholder.style.display = 'none';

        // Verfifier si on est sur le premier oui / non des axes de l'appel à projet
        if (groupId == '0') {
          // Rechercher le select de domaines d'activité pour mettre directement en patrimoine naturel
          const groupToExclude = document.querySelector('[data-id="34"]');
          // groupToExclude.style.display = 'none';
          const selectField = groupToExclude.querySelector('select');
          if (selectField) selectField.value = 'Patrimoine naturel';
        }

        this.inputChange();
      });

      no.addEventListener('click', () => {

        input.value = (noPlaceholder && input.hasAttribute('required')) ? '' : 'non'; // vide si required + placeholder / autrement c'est "non"
        no.classList.add('form-page__field__yesno--active-no');
        yes.classList.remove('form-page__field__yesno--active-yes');

        // on affiche le placeholder
        if (noPlaceholder) noPlaceholder.style.display = 'block';

        // on cache le groupe suivant
        if (groupInfos) groupInfos.style.display = 'none';

        this.inputChange();

        // Verfifier si on est sur le premier oui / non des axes de l'appel à projet
        if (groupId == '0') {
          // Rechercher le select de domaines d'activité pour mettre directement en patrimoine naturel
          const groupToExclude = document.querySelector('[data-id="34"]');
          groupToExclude.style.display = 'none';
          const selectField = groupToExclude.querySelector('select');
          if (selectField) selectField.value = 'Patrimoine bâti';
        }

      });

    });
  }

  initChoices() {
    const container = this.container.querySelectorAll(
      '.form-page__field__choix'
    );

    Array.from(container, (c, i) => {
      const items = c.querySelectorAll('.form-page__field__choix__item');

      const input = c.parentElement.getElementsByTagName('input')[0];
      input.value = '';

      Array.from(items, (item, index) => {
        /*if (index === 0) {
          item.classList.add("form-page__field__choix__item--active");
        }*/
        item.addEventListener('click', () => {
          Array.from(items, (i) => {
            i.classList.remove('form-page__field__choix__item--active');
          });

          const value = item.textContent;
          input.value = value;
          item.classList.add('form-page__field__choix__item--active');
        });
      });
    });
  }

  fillInputs() {
    const sectionInputs = this.container.getElementsByTagName('input');
    const sectionTextAreas = this.container.getElementsByTagName('textarea');

    Array.from(sectionInputs, (field, index) => {
      const placeholder = field.placeholder;

      if (field.type === 'date') {
        field.value = '2025-01-01';
      } else {
        field.value = placeholder;
      }
    });

    Array.from(sectionTextAreas, (field, index) => {
      const placeholder = field.placeholder;
      field.innerHTML = placeholder;
    });
  }

  initDropzones() {
    let __self = this;
    /* const isValidFile = file => {
      switch (file.type) {
        case "image/jpeg":
        case "image/jpg":
        case "image/png":
        case "application/pdf":
        case "text/csv":
        case "application/msword":
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
          return true;
        default:
          return false;
      }
      return false;
    };*/
    let _this = this;

    Array.from(this.dropzones, (dropDiv, index) => {
      this.files[index] = [];
      const acceptedFiles = dropDiv.getAttribute('data-types');
      const maxSize = dropDiv.getAttribute('data-size');
      let maxFiles = dropDiv.getAttribute('data-files');
      maxFiles = maxFiles == -1 ? null : maxFiles;

      const myDropzone = new Dropzone(dropDiv, {
        url: '/formulaire-de-depot-de-projet-en-ligne',
        dictInvalidFileType: 'Ce type de fichier est invalide',
        maxFilesize: maxSize, // MB
        autoDiscover: false,
        addRemoveLinks: true,
        maxFiles: maxFiles,
        dictCancelUpload: 'Supprimer',
        dictCancelUploadConfirmation: 'Voulez-vous le supprimer ?',
        dictRemoveFile: 'Supprimer',
        acceptedFiles: acceptedFiles,
        renameFile: function (file) {
          /*return (file.renameFilename =
            Date.now() + Math.random() + '.' + file.name.split('.').pop());*/
          const extension = file.name.split('.').pop();
          const name =
            _this.stringToSlug(_this.removeExtension(file.name)) +
            '-' +
            Date.now();
          return (file.renameFilename = name + '.' + extension);
        },
        error: function () {},
        complete: function (file, done) {
          if (file.accepted) {
            __self.files[index].push(file.renameFilename);
            const inputFile =
              dropDiv.parentElement.querySelector('.input-file');
            inputFile.value = __self.files[index];
            _this.inputChange();
            //console.log("complete", __self.files[index]);
          }
        },
        init: function () {
          //this.on("addedfile", handleFileAdded);
          //this.on("removedfile", handleFileRemoved);
          this.on('error', function (file) {
            if (!file.accepted) this.removeFile(file);
          });
        },
      });
    });
  }

  checkRequiredFields(sectionId, callback) {
    const section = this.sections[sectionId];
    if (!section.sectionClicked) {
      callback([]);
      return;
    }

    const sectionInputs = section.getElementsByTagName('input');
    const sectionTextAreas = section.getElementsByTagName('textarea');
    const sectionSelects = section.getElementsByTagName('select');

    let errors = [];
    Array.from(sectionInputs, (field, index) => {
      const { required, value, classList } = field;

      if (classList.contains('input-file')) {
        let maxFiles = field.getAttribute('data-files');
        if (required && maxFiles !== -1 && value) {
          const numFiles = value.split(',');
          if (numFiles.length < maxFiles) {
            errors.push(field);
          }
        }
      }

      if (required && !value) {
        errors.push(field);
        /** Si le champs est dans un groupe requis et que le groupe est déployé */
        if (
          field.parentElement.parentElement &&
          field.parentElement.parentElement.classList.contains(
            'form-page__group'
          ) &&
          field.parentElement.parentElement.style.display === 'none'
        ) {
          //  console.log('input');
          errors.pop();
        }
      }
    });
    Array.from(sectionTextAreas, (field, index) => {
      const { required, value } = field;
      if (required && !value) {
        errors.push(field);
      }
    });
    Array.from(sectionSelects, (field, index) => {
      const { required, value } = field;
      if (required && !value) {
        errors.push(field);
      }
    });

    callback(errors);
  }

  clearErrors(sectionId) {
    const sectionInputs =
      this.sections[sectionId].getElementsByTagName('input');
    const sectionTextareas =
      this.sections[sectionId].getElementsByTagName('textarea');
    const sectionLabels =
      this.sections[sectionId].getElementsByTagName('label');
    const sectionSelects =
      this.sections[sectionId].getElementsByTagName('select');

    const errorsContainer =
      this.sections[sectionId].querySelector('.form-page__errors');
    errorsContainer.innerHTML = '';

    Array.from(sectionInputs, (field, index) => {
      field.classList.remove('form-page__field--required');
    });

    Array.from(sectionTextareas, (field, index) => {
      field.classList.remove('form-page__field--required');
    });

    Array.from(sectionSelects, (field, index) => {
      field.classList.remove('form-page__field--required');
    });

    Array.from(sectionLabels, (field, index) => {
      const ast = field.querySelector('.form-page__ast--required');
      if (ast) {
        ast.classList.remove('form-page__ast--required');
      }
    });
  }

  showErrors(sectionId, errors) {
    this.clearErrors(sectionId);
    const errorsContainer =
      this.sections[sectionId].querySelector('.form-page__errors');
    errorsContainer.innerHTML = '<strong>Champs requis :<strong><br>';
    errors.map((e) => {
      const errorLabel = e.parentElement.getElementsByTagName('label')[0];
      const errorText = errorLabel.textContent;
      const errorAst = errorLabel.querySelector('.ast');
      errorsContainer.innerHTML += errorText + '<br>';
      e.classList.add('form-page__field--required');
      if (errorAst) errorAst.classList.add('form-page__ast--required');
    });
  }

  onNextSection() {
    const section = this.sections[this.activeSection];
    section.sectionClicked = true;
    this.checkRequiredFields(this.activeSection, (errors) => {
      //console.log("res errors", errors.length);
      if (errors.length) {
        this.showErrors(this.activeSection, errors);
      } else {
        this.clearErrors(this.activeSection);
        this.activeSection++;
        if (this.activeSection < 5) {
          this.showSection(this.activeSection);
          this.scrollToTop();
        }
      }
    });
  }

  onPrevSection() {
    this.activeSection--;
    this.showSection(this.activeSection);
    this.scrollToTop();
  }

  scrollToTop() {
    TweenLite.to(window, 0, {
      scrollTo: { y: this.nav, offsetY: 110 },
      ease: Power2.easeInOut,
    });
  }

  showSection(sectionId) {
    Array.from(this.sections, (section, index) => {
      section.classList.remove('form-page__section--active');
      if (index === sectionId) {
        section.classList.add('form-page__section--active');
      }
    });
    this.setNav(sectionId);
  }

  setNav(sectionId) {
    Array.from(this.navBtns, (nav, index) => {
      nav.classList.remove('form-page__nav__li--active');
      if (index === sectionId) {
        nav.classList.add('form-page__nav__li--active');
      }
      if (index < sectionId) {
        nav.classList.add('form-page__nav__li--pre');
      }
    });
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/js/components/Form.js